import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";

import styles from "./ReportsChart.module.css";
import Typography from "@mui/material/Typography";
import DashboardTooltip from "./DashboardTooltip";
import PropTypes from "prop-types";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);

const options = {
  responsive: true,
  maintainAspectRatio: true,
  interaction: {
    mode: "index",
    intersect: false,
  },
  scales: {
    x: {
      type: "category", // 👈 this fixes your "category is not a scale" issue
      title: {
        display: true,
        text: "Month",
      },
    },
    y: {
      type: "linear",
      display: true,
      position: "left",
      min: 0,
      ticks: {
        precision: 0,
      },
    },
  },
};

const setReportsData = ({ data }) => {
  return {
    labels: data.map((item) => item.month),
    datasets: [
      {
        label: "Registrations",
        data: data.map((item) => item.registrations),
        borderColor: "#4BC0C0",
        backgroundColor: "#4BC0C0",
        yAxisID: "y",
        borderWidth: 2,
        pointRadius: 3,
        tension: 0.3,
      },
      {
        label: "Webinars",
        data: data.map((item) => item.webinars),
        borderColor: "#9966FF",
        backgroundColor: "#9966FF",
        yAxisID: "y",
        borderWidth: 2,
        pointRadius: 3,
        tension: 0.3,
      },
    ],
  };
};

const ReportsChart = ({ data }) => {
  console.log("data", data);
  return (
    <div className={styles.ChartContainer}>
      {data.length > 0 ? (
        <div className={styles.ResponsiveChart}>
          <div className={styles.Title}>
            Webinar Activity
            <DashboardTooltip>
              <Typography color="inherit">Registrations</Typography>
              Total number of registrations per month.
              <Typography color="inherit">Webinars</Typography>
              Number of webinars you hosted per month.
            </DashboardTooltip>
          </div>

          <Line
            options={options}
            data={setReportsData({ data })}
            height={210}
          />
        </div>
      ) : (
        <div className={styles.ResponsiveChart}>
          <div className={styles.Title}>Webinar Activity</div>
          No registration or webinar data available yet.
        </div>
      )}
    </div>
  );
};

ReportsChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      month: PropTypes.string.isRequired,
      webinars: PropTypes.number.isRequired,
      registrations: PropTypes.number.isRequired,
    }),
  ).isRequired,
};

export default ReportsChart;
